/*Home*/
import React from 'react';
import { Link } from 'react-scroll';
import styles from './Home.module.css';
import facumed from '../assets/images/facumed.jpg';
import acred from '../assets/images/acreditacion.jfif';

const Home = () => {
  return (
    <div className={styles.home}>
      <div className={styles.titleContainer}>
        <div className={styles.imageContainer}>
          <img src={facumed} alt="Fachada Facultad de Medicina" className={styles.headerImage} />
        </div>
        <div className={styles.columna}>
          <h2>Nunca olvides tu <span className={styles.highlight}>Misión</span></h2>
          <p className={styles.misvis}>
            La Facultad de Medicina tiene como propósito formar profesionales médicos, generales e
            integrales, con principios, valores éticos y morales, comprometidos y conocedores de su realidad
            económica y cultural del país, concientizados con su entorno social, capaces de enfrentar los
            problemas de salud en sus fases de promoción, prevención, tratamiento y rehabilitación,
            enfatizando en las enfermedades prevalentes y trabajando sobre la base de los métodos científicos
            y de investigación, convirtiéndose en líder, administrador y educador, con base en la atención
            primaria de salud aplicada a los diferentes niveles de atención.
          </p>
        </div>
        <div className={styles.columna}>
          <h2>Nunca pierdas tu <span className={styles.highlight}>Visión</span></h2>
          <p className={styles.misvis}>
            La Facultad de Medicina de la Universidad Autónoma Tomás Frías (UATF) tiene como
            visión alcanzar en las próximas gestiones una unidad académica competitiva y pertinente con
            la sociedad basada en la interculturalidad, líder en la formación de recursos humanos en el área
            de la salud, con reconocimiento a nivel nacional e internacional.
          </p>
        </div>
      </div>
    
        <h2><span className={styles.acreditit}>Rumbo a la Acreditación</span></h2>
      <div className={styles.acredit}>
        <img src={acred} alt="Acreditación"/>
      </div>
      {/*<div className={styles.ctaContainer}>
        <Link to="Contact" smooth duration={500} className={styles.callToAction}>
          Misión
        </Link>
        <Link to="Contact" smooth duration={500} className={styles.callToAction}>
          Visión
        </Link>
      </div>*/}
      
      <div >                    
          <p className={styles.acreditext}>
            Con el firme propósito de elevar la calidad académica y avanzar hacia un modelo educativo basado en competencias, 
            la Carrera de Medicina de la Universidad Autónoma “Tomás Frías” ha desarrollado, durante más de un año, 
            un proceso integral de transformación. Este camino comenzó con un diagnóstico institucional en mayo y junio de 2024,
            seguido por un estudio de contexto en agosto. En paralelo, se elaboró y logró la aprobación del Informe de Rediseño Curricular
            en la Reunión Académica Nacional (RAN) en septiembre de 2024, un hecho histórico para nuestra Facultad, al ser la primera vez que 
            nuestro plan de estudios fue validado oficialmente a nivel nacional.
          </p>
          <p className={styles.acreditext}>
            Este logro marcó un punto de inflexión y nos impulsó con renovado compromiso hacia la etapa de autoevaluación, 
            como preparación para la visita del Comité de Pares Evaluadores del sistema ARCUSUR. Hoy, con entusiasmo y responsabilidad, 
            abrimos nuestras puertas al escrutinio externo, convencidos de que este proceso refleja la dedicación de una comunidad que cree 
            en la mejora continua, en la excelencia formativa y en el poder transformador de la educación médica para el país y la región.
          </p>
        </div>
    </div>
    
  );
};

export default Home;
